import { useState } from "react";
import TrafficList from "../components/TrafficList";
import TrafficInspector from "../components/TrafficInspector";
import Sidebar from "../components/Sidebar";

export default function Traffic() {
  const [selectedId, setSelectedId] = useState<number | null>(null);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar />
      <main className="flex-1 flex flex-col md:flex-row p-0">
        <TrafficList onSelect={setSelectedId} selectedId={selectedId} />
        <TrafficInspector selectedId={selectedId} />
      </main>
    </div>
  );
}
